import { toast } from 'react-toastify';

export const CustomToast = ({ title, message }: any): any => (
  <div
    style={{
      padding: '8px',
      color: '#111827',
    }}
  >
    <div style={{ fontWeight: 600, marginBottom: 4 }}>{title}</div>
    <div style={{ fontSize: '0.875rem', color: '#6B7280' }}>{message}</div>
  </div>
);

type ToastFunction = (message: string, options?: object) => void;

const showSuccessMessage: ToastFunction = (message, options) => {
  toast.success(message, { pauseOnFocusLoss: false, ...options });
};

const showInfoMessage: ToastFunction = (message, options) => {
  toast.info(message, { pauseOnFocusLoss: false, ...options });
};

const showErrorMessage: ToastFunction = (message, options) => {
  toast.error(message, { pauseOnFocusLoss: false, ...options });
};

const showToastAtBottom = (title: string, message: string): void => {
  toast(<CustomToast title={title} message={message} />, {
    position: 'bottom-right',
    closeButton: false,
    hideProgressBar: true,
    pauseOnHover: true,
    draggable: true,
  });
};

// Toast with options available on https://fkhadra.github.io/react-toastify/introduction/
const showToast = (
  toastFunction: ToastFunction,
  message: string,
  options?: object
): void => {
  toastFunction(message, { pauseOnFocusLoss: false, ...options });
};

export default {
  showSuccessMessage,
  showInfoMessage,
  showErrorMessage,
  showToast,
  toast,
  showToastAtBottom,
};
